// extracted by mini-css-extract-plugin
module.exports = {"schoolInfoPage":"DrivingSchoolInfoPage_schoolInfoPage__1e_r4","linkBtn":"DrivingSchoolInfoPage_linkBtn__2SBkH"};